import { useEffect, useState } from 'react'
import styled, { useTheme } from 'styled-components'

import { InfoIcon } from '@/components/shared/icons/InfoIcon'

type ArchiveMessageProps = {
  updatedDate?: string
  daysUntilOutdated?: number
}

const StyledArchiveMessage = styled.div`
  color: ${(props) => props.theme.v2.warning.bright};
  display: flex;
  align-items: center;
  & > p {
    margin: 0 0 0 8px;
    font-size: 14px;
    line-height: 20px;
    padding: 0;
  }
`

const MS_PER_DAY = 24 * 60 * 60 * 1000
const isOutdated = (updatedAt: Date, daysUntilOutdated: number) => {
  const now = new Date()

  const timeDiffInMs = now.getTime() - updatedAt.getTime()
  const timeDiffInDays = timeDiffInMs / MS_PER_DAY

  return timeDiffInDays >= daysUntilOutdated
}

export const ArchiveMessage = ({ updatedDate, daysUntilOutdated = 90 }: ArchiveMessageProps) => {
  const theme = useTheme()
  const [showNotice, setShowNotice] = useState<boolean>(false)

  useEffect(() => {
    setShowNotice(!!updatedDate && isOutdated(new Date(updatedDate), daysUntilOutdated))
  }, [updatedDate, daysUntilOutdated])

  return (
    <>
      {showNotice && (
        <StyledArchiveMessage>
          <InfoIcon colour={theme.colours.brand} />
          <p data-testid="archive-message">This article has not been updated recently</p>
        </StyledArchiveMessage>
      )}
    </>
  )
}
